export const SET_CALENDAR_LOADING = 'SET_CALENDAR_LOADING'
export const GET_ALL_DATA = 'GET_ALL_DATA'
export const GET_EVENT = 'GET_EVENT'
